import { z } from "zod";
import { ADDRESS, ADDRESS_1, ADDRESS_2, CATEGORY, CITY, COMMUNITY_ID, COMMUNITY_NAME, COUNTRY, EMERGENCY_CONTACTS, INSURANCE_TYPE, NO_OF_GARAGES, PIN, POC_EMAIL, POC_MOB_NO, POC_NAME, PROPERTY_BLOCK, PROPERTY_ID, PROPERTY_MODEL, PROPERTY_NAME, PROPERTY_SIZE, PROPERTY_ZONE, STATE, UNIT_NUMBER, ZIPCODE } from "./consts";

export const propertySchema = z.object({
  [PROPERTY_ID]: z.string().optional(),
  [PROPERTY_NAME]: z.string().min(1, "This field is required"),
  [UNIT_NUMBER]: z.string().min(3, "Minimum Length of this field is 3"),
  [PIN]: z.string().max(15, "Maximum length of this field is 15").optional(),
  [INSURANCE_TYPE]: z.string().optional(),
  [CATEGORY]: z.string().min(1, "This field is required"),
  [PROPERTY_ZONE]: z.string().optional(),
  [PROPERTY_BLOCK]: z.string().optional(),
  [PROPERTY_MODEL]: z.string().min(1, "This field is required"),
  [PROPERTY_SIZE]: z.string().min(1, "This field is required"),
  [NO_OF_GARAGES]: z.string().optional(),
  // [IS_RENTED]: z.boolean().optional(),
  [ADDRESS]: z.object({
    [ADDRESS_1]: z.string().min(1, "This field is required"),
    [ADDRESS_2]: z.string().optional(),
    [STATE]: z.string().min(1, "This field is required"),
    [CITY]: z.string().min(1, "This field is required"),
    [ZIPCODE]: z
      .string()
      .min(1, "This field is required")
      .regex(/^[0-9]{5}(-[0-9]{4})?$/, "Enter ZIP code as XXXXX or XXXXX-XXXX."),
    [COUNTRY]: z.string().min(1, "This field is required"),
  }),
  [EMERGENCY_CONTACTS]: z
    .array(
      z.object({
        [POC_NAME]: z.string().optional(),
        [POC_MOB_NO]: z.string().optional(),
        [POC_EMAIL]: z
          .string()
          .optional()
          .refine((val) => !val || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val), {
            message: "Invalid Email",
          }),
      })
    ).optional(),
    // .min(1, "At least one emergency contact is required"),
  [COMMUNITY_ID]: z.string().min(1, "This field is required"),
  [COMMUNITY_NAME]: z.string().optional(),
});

export type communityFormValues = z.infer<typeof propertySchema>;
